import React from "react";
import { ChevronUp, ChevronDown } from "lucide-react";

// Numeric stepper with type-in input, ▲/▼ buttons, keyboard arrows, clamp on blur,
// and an optional unit label. Replaces all sliders (Update 14).
export default function NumericStepper({ value, onChange, min = 0, max = 999, step = 1, unit = "", testid }) {
  const clamp = (n) => Math.max(min, Math.min(max, n));
  const set = (n) => { if (!Number.isNaN(n)) onChange(clamp(n)); };
  const cur = Number(value) || 0;
  return (
    <div className="inline-flex items-center gap-1">
      <div className="flex items-stretch border border-[#2a2a2a] rounded-[4px] overflow-hidden bg-[#0e0e0e]">
        <input type="number" value={value} min={min} max={max} step={step}
               onChange={(e) => set(Number(e.target.value))}
               onBlur={(e) => set(clamp(Number(e.target.value)))}
               data-testid={testid}
               className="w-[50px] bg-transparent text-xs px-2 py-1 outline-none text-[#e8e8e8] [appearance:textfield]" />
        <div className="flex flex-col border-l border-[#2a2a2a]">
          <button type="button" tabIndex={-1} onClick={() => set(cur + step)} aria-label="Increase"
                  data-testid={testid ? `${testid}-up` : undefined}
                  className="px-1 flex items-center justify-center text-[#8a8a8a] hover:text-white hover:bg-[#1a1a1a] flex-1"><ChevronUp size={11} /></button>
          <button type="button" tabIndex={-1} onClick={() => set(cur - step)} aria-label="Decrease"
                  data-testid={testid ? `${testid}-down` : undefined}
                  className="px-1 flex items-center justify-center text-[#8a8a8a] hover:text-white hover:bg-[#1a1a1a] flex-1 border-t border-[#2a2a2a]"><ChevronDown size={11} /></button>
        </div>
      </div>
      {unit && <span className="text-[10px] text-[#6a6a6a] w-4">{unit}</span>}
    </div>
  );
}
